<div class="title-bar-container" *ngIf="layoutService.titleKey$.value.value">
  <div class="title-bar-title">
    <span class="title-bar-heading">{{ layoutService.titleKey$.value.title }}</span>
  </div>
  <div class="title-bar-actions">
    <ng-container *ngTemplateOutlet="layoutService.titleBarActionsTemplate$.value"> </ng-container>
  </div>
</div>
